import { render, staticRenderFns } from "./News.vue?vue&type=template&id=bc49c5d8"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=bc49c5d8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FixedBackground: require('/vercel/path0/components/elements/FixedBackground.vue').default,PageHeaderNews: require('/vercel/path0/components/page/HeaderNews.vue').default,PageFooter: require('/vercel/path0/components/page/Footer.vue').default})
